/** 
 * @type {AdministratorsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    names: null,
}
/** 
* @returns {AdministratorsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/AdministratorsFilter.js